import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { HttpService } from '../../../services/common/http/common.http.service';

@Component({
  selector: 'app-nova-senha-layout',
  templateUrl: './nova-senha-layout.component.html',
  styleUrl: './nova-senha-layout.component.scss',
})
export class NovaSenhaComponent implements OnInit {
  form = {
    senha: '',
    novaSenha: '',
  };
  isLengthValid = false;
  hasNumber = false;
  hasLowercase = false;
  hasUppercase = false;
  hasSpecialChar = false;
  passwordsMatch = false;
  isValid = false;

  constructor(
    private httpService: HttpService,
    private router: Router,
    private toast: ToastrService
  ) {}

  ngOnInit(): void {
    localStorage.clear();
  }

  validatePassword() {
    const senha = this.form.senha;
    const novaSenha = this.form.novaSenha;

    this.isLengthValid = senha.length >= 8;
    this.hasNumber = /\d/.test(senha);
    this.hasLowercase = /[a-z]/.test(senha);
    this.hasUppercase = /[A-Z]/.test(senha);
    this.hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(senha);
    this.passwordsMatch = senha === novaSenha;

    if (
      this.isLengthValid &&
      this.hasNumber &&
      this.hasLowercase &&
      this.hasUppercase &&
      this.hasSpecialChar &&
      this.passwordsMatch
    ) {
      this.isValid = true;
    } else {
      this.isValid = false;
    }
  }

  definirNovaSenha() {
    if (this.isValid) {
      const payload = this.createPayload(this.form);

      this.httpService
        .usePatch('AtualizarSenha', payload, payload.IdUsuario)
        .subscribe({
          next: (response: any) => {
            this.toast.success('Senha definida com sucesso.');
            this.router.navigate(['login']);
          },
          error: (error: any) => {
            this.toast.error(
              'Ocorreu uma falha ao realizar a redefinição de senha, por favor, tente novamente!'
            );
          },
        });
    }
  }

  createPayload(form: any) {
    localStorage.clear();
    const url = this.router.url;

    const [usuarioIdPart, tokenPart] = url.split(',');
    const usuarioId = usuarioIdPart.split(':')[1];
    const token = tokenPart.split(':')[1].replace('=', '');

    localStorage.setItem('Token', String(`"${token}"`));

    const body = {
      IdUsuario: Number(usuarioId),
      Password: form.senha,
    };
    return body;
  }
}
